import PropTypes from 'prop-types';
import React from 'react';

import { Asterisks } from './TrlAsterisks.styles';

export const TrlAsterisks = ({ areVisible }) => (
  <Asterisks areVisible={areVisible}>*</Asterisks>
);

TrlAsterisks.propTypes = {
  areVisible: PropTypes.bool.isRequired,
};
